module.exports = __webpack_public_path__ + "static/media/70.4c2dda4e.jpg";